module.exports = __webpack_public_path__ + "img/12_dice[6].9da0cf9c.png";